export const ANTHE_EXAM_TYPES = ['anthe', 'akthe', 'iat']

export const ANTHE_TEST_TYPES = ['anthetesting', 'anthe_testing']
